import { render, staticRenderFns } from "./Controlhead.vue?vue&type=template&id=ffed4fdc&"
import script from "./Controlhead.vue?vue&type=script&lang=js&"
export * from "./Controlhead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports